import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export const RequireAuth = ({ children, admin = false }) => {
  const { user, setAuthOpen } = useAuth();
  if (user === null) return <div className="p-10 text-center text-sm text-slate-400">Loading…</div>;
  if (!user)
    return (
      <div className="mx-auto max-w-md space-y-4 rounded-xl border border-[#1E293B] bg-[#121824] p-8 text-center">
        <h2 className="font-display text-2xl font-black uppercase">Log in to continue</h2>
        <p className="text-sm text-slate-400">Use your cell number and password.</p>
        <Button data-testid="require-auth-login" onClick={() => setAuthOpen(true)} className="bg-[#10B981] font-bold text-[#0B0E14]">
          Log in / Join
        </Button>
      </div>
    );
  if (admin && user.role !== "admin") return <div className="p-10 text-center text-sm text-slate-400">Admins only.</div>;
  return children;
};
